import styled from 'styled-components';
import NextImage from 'next/image';
import breakpoints from '@/theme/constants/breakpoints';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import pxToRem from '@/theme/helpers/pxToRem';
import colors from '@/theme/constants/colors';

export const StyledUspHeading = styled.h1`
  ${typography.Section}
  margin-bottom: ${sizePx(16)};
  text-align: center;

  @media only screen and ${breakpoints.device.l} {
    margin-bottom: ${sizePx(20)};
  }
`;

export const StyledUspContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: ${sizePx(16)} ${sizePx(8)};
  align-items: start;
  justify-items: center;

  @media only screen and ${breakpoints.device.m} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }
`;

export const StyledImageUspContainer = styled.div`
  max-width: 276px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    margin-top: 8px;
    ${typography.Art}
    color: ${colors.darkBlue100};
    text-align: center;
    cursor: default;
    }
  }
`;

export const StyledNextImage = styled(NextImage)`
  width: 34px;
  height: 34px;
  background: trasparent;

  @media only screen and ${breakpoints.device.l} {
      width: 48px;
      height: 48px;
      font-size: ${pxToRem(19)};
`;
